import React from 'react'
import { Link } from 'react-router-dom'

const APIlafDetail = ({row}) => {
    return (
        <Link 
            to={`/api-logs/${row?.cl_lead_id}/${row?.cl_lender_id}/${row?.lead_type}`}
        >
            {row?.laf_id}
        </Link>
    )
}

export default APIlafDetail